// document.addEventListener("DOMContentLoaded", function () {
//     const productFormNames = document.getElementsByClassName("shopify-product-form")[1];
//     const productForm = document.getElementById(productFormNames.getAttribute("id"));
//     if (productFormNames.length > 1) {
//         const productForm = productFormNames[1];
//     }

//     if (!productForm) return;

//     const addToCartBtn = productForm.querySelector(".product-add-to-cart__button");

//     const locationPrices = {
//         "Milan": 600,
//         "Amsterdam": 600,
//         "Geneva": 600,
//         "Bruxelles": 600,
//         "Vienna": 1000,
//         "Cannes": 1000
//     };

//     const formatCurrency = (val) =>
//         val === 0 ? "Free" : new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(val);

//     // ✅ READ BOOKED DATES FROM SHOPIFY PRODUCT METAFIELDS
//     let BOOKED_DATES = [];
    
//     // This will be populated by Liquid template
//     if (typeof window.RENTAL_BOOKED_DATES !== 'undefined') {
//         BOOKED_DATES = window.RENTAL_BOOKED_DATES;
//     }

//     // Build widget HTML
//     const rentalWidget = window.RENTAL_CALCULATOR_HTML || '';
//     addToCartBtn.insertAdjacentHTML("beforebegin", rentalWidget);

//     // Elements
//     const pickupDate = document.getElementById("pickup-date");
//     const dropoffDate = document.getElementById("dropoff-date");
//     const pickupTime = document.getElementById("pickup-time-select");
//     const dropoffTime = document.getElementById("dropoff-time-select");
//     const pickupLocation = document.getElementById("pickup-location");
//     const dropoffLocation = document.getElementById("dropoff-location");
//     const errorMsg = document.getElementById("error-msg");

//     const dailyRateEl = document.getElementById("daily-rate");
//     const rentalDaysEl = document.getElementById("rental-days");
//     const totalPriceEl = document.getElementById("total-price");
//     const rateLabelEl = document.getElementById("rate-label");
//     const durationLabelEl = document.getElementById("duration-label");

//     const rentalTotalHidden = document.getElementById("rental-total-hidden");
//     const rentalTotalNumeric = document.getElementById("rental-total-numeric");
//     const rentalDaysHidden = document.getElementById("rental-days-hidden");
//     const pickupFeeHidden = document.getElementById("pickup-fee-hidden");
//     const dropoffFeeHidden = document.getElementById("dropoff-fee-hidden");

//     let dailyRate = window.RENTAL_DAILY_RATE || 0;
//     let currentServiceType = null;
//     let isDateRangeValid = false;

//     function checkAndClearSessionData() {
//         const urlParams = new URLSearchParams(window.location.search);
//         const fromSearch = urlParams.get('from_search');
//         if (!fromSearch || fromSearch !== 'true') {
//             sessionStorage.removeItem('rentalData');
//             sessionStorage.removeItem('rentalSearchData');
//             return false;
//         }
//         return true;
//     }

//     function detectServiceType() {
//         try {
//             const rentalData = sessionStorage.getItem('rentalData');
//             if (rentalData) {
//                 const data = JSON.parse(rentalData);
//                 if (data.serviceType) {
//                     currentServiceType = data.serviceType;
//                     return currentServiceType;
//                 }
//             }
//         } catch (e) {}
//         const variantSelector = document.querySelector('input[name="option1"]:checked');
//         if (variantSelector) {
//             const variantTitle = variantSelector.value.toLowerCase();
//             if (variantTitle.includes('chauffeur')) {
//                 currentServiceType = 'chauffeur';
//             } else if (variantTitle.includes('self drive') || variantTitle.includes('self-drive')) {
//                 currentServiceType = 'self-drive';
//             } else if (variantTitle.includes('transfer')) {
//                 currentServiceType = 'transfer';
//             }
//         }
//         return currentServiceType;
//     }

//     function checkDateAvailability() {
//         if (!pickupDate.value || !dropoffDate.value) {
//             return { available: true, message: '' };
//         }
//         const selectedStart = new Date(pickupDate.value);
//         selectedStart.setHours(0, 0, 0, 0);
//         const selectedEnd = new Date(dropoffDate.value);
//         selectedEnd.setHours(23, 59, 59, 999);
//         for (let booking of BOOKED_DATES) {
//             const bookedStart = new Date(booking.start);
//             bookedStart.setHours(0, 0, 0, 0);
//             const bookedEnd = new Date(booking.end);
//             bookedEnd.setHours(23, 59, 59, 999);
//             if (selectedStart <= bookedEnd && selectedEnd >= bookedStart) {
//                 const formatDate = (date) => {
//                     const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//                     return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
//                 };
//                 return {
//                     available: false,
//                     message: `⚠️ This car is already booked from ${formatDate(bookedStart)} to ${formatDate(bookedEnd)}. Please select different dates.`
//                 };
//             }
//         }
//         return { available: true, message: '' };
//     }

//     function setMinDateTime() {
//         const now = new Date();
//         const yyyy = now.getFullYear();
//         const mm = String(now.getMonth() + 1).padStart(2, "0");
//         const dd = String(now.getDate()).padStart(2, "0");
//         const today = `${yyyy}-${mm}-${dd}`;
//         pickupDate.min = today;
//         dropoffDate.min = today;
//     }
//     setMinDateTime();

//     function validateDatesAndTimes() {
//         errorMsg.style.display = "none";
//         errorMsg.textContent = "";
        
//         if (!pickupDate.value || !dropoffDate.value || !pickupTime.value || !dropoffTime.value) {
//             return { valid: false, message: "" };
//         }
        
//         const now = new Date();
//         const pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
//         const dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
        
//         if (pickupDT < now) {
//             return { valid: false, message: "⚠️ Pick-up date and time cannot be in the past." };
//         }
        
//         if (dropoffDT < now) {
//             return { valid: false, message: "⚠️ Drop-off date and time cannot be in the past." };
//         }
        
//         if (dropoffDT <= pickupDT) {
//             return { valid: false, message: "⚠️ Drop-off date and time must be after pick-up." };
//         }
        
//         const diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
        
//         if (!currentServiceType) { detectServiceType(); }
        
//         if (currentServiceType === 'chauffeur') {
//             if (diffHours < 4) {
//                 return { valid: false, message: "⚠️ Chauffeur Service requires a minimum booking of 4 hours." };
//             }
            
//             const variantSelector = document.querySelector('input[name="option1"]:checked');
//             if (variantSelector) {
//                 const variantTitle = variantSelector.value;
//                 const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
//                 if (hourMatch) {
//                     const variantMinHours = parseInt(hourMatch[1]);
//                     const totalHours = Math.ceil(diffHours);
//                     if (totalHours < variantMinHours) {
//                         return { 
//                             valid: false, 
//                             message: `⚠️ This variant requires a minimum of ${variantMinHours} hours. Your booking is ${totalHours} hour${totalHours !== 1 ? 's' : ''}. Please select more hours or choose a different variant.` 
//                         };
//                     }
//                 }
//             }
//         } else if (currentServiceType === 'self-drive') {
//             if (diffHours < 12) {
//                 return { valid: false, message: "⚠️ Self-Drive service requires a minimum rental of 12 hours." };
//             }
//         } else if (currentServiceType === 'transfer') {
//             if (diffHours < 0.5) {
//                 return { valid: false, message: "⚠️ Transfer duration must be at least 30 minutes." };
//             }
//         } else {
//             if (diffHours < 12) {
//                 return { valid: false, message: "⚠️ Minimum rental duration is 12 hours." };
//             }
//         }
        
//         const diffDays = diffHours / 24;
//         if (diffDays > 90) {
//             return { valid: false, message: "⚠️ Maximum rental duration is 90 days. Please contact us for longer rentals." };
//         }
        
//         return { valid: true, message: "" };
//     }

//     function calculatePrice() {
//         errorMsg.style.display = "none";
//         isDateRangeValid = false;
//         if (!currentServiceType) { detectServiceType(); }
//         let pickupFee = 0;
//         let dropoffFee = locationPrices[dropoffLocation.value] || 0;
//         let days = 0;
//         let total = 0;
        
//         const validation = validateDatesAndTimes();
//         if (!validation.valid) {
//             if (validation.message) {
//                 errorMsg.textContent = validation.message;
//                 errorMsg.style.display = "block";
//             }
//             rentalDaysEl.textContent = '0';
//             totalPriceEl.textContent = '-';
//             updatePaymentInfo(0, 0);
//             isDateRangeValid = false;
//             updateButtonStates();
//             return;
//         }
        
//         if (currentServiceType === 'transfer') {
//             rateLabelEl.textContent = 'Daily Rate';
//             durationLabelEl.textContent = 'Rental Days';
//             rentalDaysEl.textContent = '0';
//             rentalDaysHidden.value = 0;
//             dailyRateEl.textContent = formatCurrency(dailyRate);
//             total = dailyRate + dropoffFee;
//         } else if (currentServiceType === 'chauffeur') {
//             // For chauffeur, check if multi-day schedule is active
//             const pickupDT = new Date(pickupDate.value + 'T00:00:00');
//             const dropoffDT = new Date(dropoffDate.value + 'T23:59:59');
//             const diffDays = Math.ceil((dropoffDT - pickupDT) / (1000 * 60 * 60 * 24));
            
//             rateLabelEl.textContent = 'Base Rate per Day';
//             durationLabelEl.textContent = 'Total Days';
            
//             const variantSelector = document.querySelector('input[name="option1"]:checked');
//             let variantMinHours = 4;
            
//             if (variantSelector) {
//                 const variantTitle = variantSelector.value;
//                 const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
//                 if (hourMatch) {
//                     variantMinHours = parseInt(hourMatch[1]);
//                 }
//             }
            
//             // Check if multi-day section is active and has times filled
//             const hasMultiDayTimes = diffDays > 1 && Object.keys(dailySchedules).length > 0 && 
//                                      Object.values(dailySchedules).some(day => day.from && day.to);
            
//             if (hasMultiDayTimes) {
//                 // Multi-day calculation: sum up each day's price
//                 let totalMultiDayPrice = 0;
//                 let totalAdditionalHours = 0;
//                 const additionalHourRate = 70;
//                 let daysWithTimes = 0;
                
//                 Object.keys(dailySchedules).forEach(index => {
//                     const daySchedule = dailySchedules[index];
//                     if (daySchedule.from && daySchedule.to) {
//                         daysWithTimes++;
//                         const fromMinutes = parseInt(daySchedule.from.split(':')[0]) * 60 + parseInt(daySchedule.from.split(':')[1]);
//                         const toMinutes = parseInt(daySchedule.to.split(':')[0]) * 60 + parseInt(daySchedule.to.split(':')[1]);
//                         let diffMinutes = toMinutes - fromMinutes;
//                         if (diffMinutes < 0) diffMinutes += 24 * 60;
                        
//                         const hours = diffMinutes / 60;
//                         const extraHours = Math.max(0, hours - variantMinHours);
                        
//                         // Each day: base rate + extra hours charge
//                         const dayPrice = dailyRate + (Math.ceil(extraHours) * additionalHourRate);
//                         totalMultiDayPrice += dayPrice;
//                         totalAdditionalHours += Math.ceil(extraHours);
//                     }
//                 });
                
//                 dailyRateEl.textContent = formatCurrency(dailyRate);
//                 rentalDaysEl.textContent = daysWithTimes;
//                 rentalDaysHidden.value = daysWithTimes;
                
//                 // Add drop-off fee to multi-day total
//                 total = totalMultiDayPrice + dropoffFee;
                
//                 // Hide single-day extra hours info for multi-day
//                 const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
//                 extraHoursInfoDiv.style.display = "none";
//             } else {
//                 // Single day calculation or multi-day without custom times
//                 if (!pickupTime.value || !dropoffTime.value) {
//                     // No times selected yet
//                     dailyRateEl.textContent = formatCurrency(dailyRate);
//                     rentalDaysEl.textContent = diffDays;
//                     rentalDaysHidden.value = diffDays;
//                     total = 0;
//                 } else {
//                     dailyRateEl.textContent = formatCurrency(dailyRate);
//                     rentalDaysEl.textContent = diffDays;
//                     rentalDaysHidden.value = diffDays;
                    
//                     const additionalHourRate = 70;
                    
//                     // For multi-day, calculate hours per day based on TIME difference only
//                     if (diffDays > 1) {
//                         // Calculate daily hours from selected times (not full datetime range)
//                         const pickupTimeMinutes = parseInt(pickupTime.value.split(':')[0]) * 60 + parseInt(pickupTime.value.split(':')[1]);
//                         const dropoffTimeMinutes = parseInt(dropoffTime.value.split(':')[0]) * 60 + parseInt(dropoffTime.value.split(':')[1]);
//                         let dailyMinutes = dropoffTimeMinutes - pickupTimeMinutes;
//                         if (dailyMinutes < 0) dailyMinutes += 24 * 60; // Handle overnight
                        
//                         const hoursPerDay = dailyMinutes / 60;
//                         const extraHoursPerDay = Math.max(0, hoursPerDay - variantMinHours);
//                         const pricePerDay = dailyRate + (Math.ceil(extraHoursPerDay) * additionalHourRate);
//                         total = (pricePerDay * diffDays) + dropoffFee;
                        
//                         // Show warning for multi-day with default times
//                         const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
//                         if (extraHoursPerDay > 0) {
//                             const roundedExtraHours = Math.ceil(extraHoursPerDay);
//                             const extraChargePerDay = roundedExtraHours * additionalHourRate;
//                             const totalExtraCharge = extraChargePerDay * diffDays;
//                             extraHoursInfoDiv.innerHTML = `⚠️ <strong>Extra Hours Per Day:</strong> ${roundedExtraHours} hour${roundedExtraHours > 1 ? 's' : ''} beyond package<br><strong>Additional Charge:</strong> €${extraChargePerDay}/day × ${diffDays} days = €${totalExtraCharge} total (€70/hour)`;
//                             extraHoursInfoDiv.style.display = "block";
//                         } else {
//                             extraHoursInfoDiv.style.display = "none";
//                         }
//                     } else {
//                         // Single day - calculate full datetime range
//                         let mainPickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
//                         let mainDropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
                        
//                         let diffHours = (mainDropoffDT - mainPickupDT) / (1000 * 60 * 60);
//                         let totalHours = Math.ceil(diffHours);
//                         let additionalHours = Math.max(0, totalHours - variantMinHours);
                        
//                         total = dailyRate + (additionalHours * additionalHourRate) + dropoffFee;
                        
//                         // Show single-day extra hours info
//                         const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
//                         if (additionalHours > 0) {
//                             const extraCharge = additionalHours * additionalHourRate;
//                             extraHoursInfoDiv.innerHTML = `⚠️ <strong>Extra Hours Selected:</strong> ${additionalHours} hour${additionalHours > 1 ? 's' : ''} beyond package<br><strong>Additional Charge:</strong> €${extraCharge} (€70/hour × ${additionalHours} hours)`;
//                             extraHoursInfoDiv.style.display = "block";
//                         } else {
//                             extraHoursInfoDiv.style.display = "none";
//                         }
//                     }
//                 }
//             }
//         } else if (currentServiceType === 'self-drive') {
//             rateLabelEl.textContent = 'Daily Rate';
//             durationLabelEl.textContent = 'Rental Days';
            
//             let pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
//             let dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
//             let diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
            
//             days = Math.ceil(diffHours / 24);
            
//             // Validate self-drive day ranges based on variant
//             const variantSelector = document.querySelector('input[name="option1"]:checked');
//             if (variantSelector) {
//                 const variantTitle = variantSelector.value.toLowerCase();
//                 let minDays = 0;
//                 let maxDays = 999;
//                 let packageName = '';
                
//                 // Extract day range from variant title (e.g., "Self Drive 4-7 days")
//                 const dayRangeMatch = variantTitle.match(/(\d+)-(\d+)\s*days?/i);
//                 if (dayRangeMatch) {
//                     minDays = parseInt(dayRangeMatch[1]);
//                     maxDays = parseInt(dayRangeMatch[2]);
//                     packageName = `Self Drive ${minDays}-${maxDays} days`;
//                 } else {
//                     // Check for single day variants like "Self Drive 1-3 days" or "3 days"
//                     const singleDayMatch = variantTitle.match(/(\d+)\s*days?/i);
//                     if (singleDayMatch) {
//                         const extractedDays = parseInt(singleDayMatch[1]);
//                         // Assume it's part of a range, try to infer
//                         if (variantTitle.includes('1') || variantTitle.includes('one')) {
//                             minDays = 1;
//                             maxDays = 3;
//                             packageName = 'Self Drive 1-3 days';
//                         }
//                     }
//                 }
                
//                 // Validate selected days against package range
//                 if (minDays > 0 && (days < minDays || days > maxDays)) {
//                     errorMsg.textContent = `⚠️ You selected the "${packageName}" package, which requires booking between ${minDays} and ${maxDays} days. You've selected ${days} day${days !== 1 ? 's' : ''}. Please adjust your dates or select a different package.`;
//                     errorMsg.style.display = "block";
//                     isDateRangeValid = false;
//                     rentalDaysEl.textContent = days;
//                     totalPriceEl.textContent = '-';
//                     updatePaymentInfo(0, 0);
//                     updateButtonStates();
//                     return;
//                 }
//             }
            
//             rentalDaysEl.textContent = days;
//             rentalDaysHidden.value = days;
//             dailyRateEl.textContent = formatCurrency(dailyRate);
            
//             const baseTotal = (days * dailyRate) + dropoffFee;
//             const franchiseAmount = 1500;
//             total = baseTotal + franchiseAmount;
//         } else {
//             rateLabelEl.textContent = 'Daily Rate';
//             durationLabelEl.textContent = 'Rental Days';
            
//             if (pickupDate.value && dropoffDate.value && pickupTime.value && dropoffTime.value) {
//                 let pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
//                 let dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
//                 let diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
//                 days = Math.ceil(diffHours / 24);
//                 rentalDaysEl.textContent = days;
//                 rentalDaysHidden.value = days;
//                 total = (days * dailyRate) + dropoffFee;
//             }
//         }
//         const availability = checkDateAvailability();
//         if (!availability.available) {
//             errorMsg.textContent = availability.message;
//             errorMsg.style.display = "block";
//             isDateRangeValid = false;
//             updateButtonStates();
//             return;
//         } else {
//             isDateRangeValid = true;
//         }
//         pickupFeeHidden.value = pickupFee;
//         dropoffFeeHidden.value = dropoffFee;
//         const formatted = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(total);
//         totalPriceEl.textContent = formatted;
//         rentalTotalHidden.value = formatted;
//         rentalTotalNumeric.value = total.toFixed(2);
        
//         updateTotalPriceInSession(total);
//         updatePaymentInfo(total, dailyRate);
//         updateButtonStates();
//     }

//     function updateTotalPriceInSession(totalPrice) {
//         try {
//             let rentalSearchData = sessionStorage.getItem('rentalSearchData');
//             let data = {};
            
//             if (rentalSearchData) {
//                 data = JSON.parse(rentalSearchData);
//             }
            
//             data.totalPrice = totalPrice;
//             data.pickupLocation = pickupLocation.value;
//             data.dropoffLocation = dropoffLocation.value;
//             data.pickupDate = pickupDate.value;
//             data.pickupTime = pickupTime.value;
//             data.returnDate = dropoffDate.value;
//             data.returnTime = dropoffTime.value;
//             data.serviceType = currentServiceType;
            
//             sessionStorage.setItem('rentalSearchData', JSON.stringify(data));
//         } catch (error) {
//             console.error('Error updating total price in session storage:', error);
//         }
//     }

//     function updatePaymentInfo(totalPrice, depositAmount) {
//         const paymentInfoBox = document.getElementById("payment-info-box");
//         const paymentTotal = document.getElementById("payment-total");
//         const paymentBalance = document.getElementById("payment-balance");
//         if (totalPrice > 0) {
//             const balance = totalPrice - depositAmount;
//             const formattedTotal = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(totalPrice);
//             const formattedBalance = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(balance);
//             paymentTotal.textContent = formattedTotal;
//             paymentBalance.textContent = formattedBalance;
//             paymentInfoBox.style.display = "block";
//         } else {
//             paymentInfoBox.style.display = "none";
//         }
//     }

//     function updateButtonStates() {
//         const paymentBtn = productForm.querySelector(".shopify-payment-button__button");
//         if (!isDateRangeValid || !pickupDate.value || !dropoffDate.value) {
//             addToCartBtn.disabled = true;
//             addToCartBtn.style.opacity = "0.5";
//             addToCartBtn.style.cursor = "not-allowed";
//             if (paymentBtn) {
//                 paymentBtn.disabled = true;
//                 paymentBtn.style.opacity = "0.5";
//                 paymentBtn.style.cursor = "not-allowed";
//             }
//         } else {
//             addToCartBtn.disabled = false;
//             addToCartBtn.style.opacity = "1";
//             addToCartBtn.style.cursor = "pointer";
//             if (paymentBtn) {
//                 paymentBtn.disabled = false;
//                 paymentBtn.style.opacity = "1";
//                 paymentBtn.style.cursor = "pointer";
//             }
//         }
//     }

//     // Multi-Day Schedule Functions
//     const multiDaySection = document.getElementById('multi-day-section');
//     const dailyScheduleContainer = document.getElementById('daily-schedule-container');
//     const defaultTimeSection = document.getElementById('default-time-section');
//     const useCustomTimesToggle = document.getElementById('use-custom-times-toggle');
//     const applyDefaultTimesBtn = document.getElementById('apply-default-times-btn');
//     let dailySchedules = {};
//     let isCustomTimesMode = false;

//     function generateDailySchedule() {
//         if (!pickupDate.value || !dropoffDate.value) {
//             multiDaySection.style.display = 'none';
//             return;
//         }

//         if (!currentServiceType) { detectServiceType(); }
//         if (currentServiceType !== 'chauffeur') {
//             multiDaySection.style.display = 'none';
//             return;
//         }

//         const pickupDT = new Date(pickupDate.value + 'T00:00:00');
//         const dropoffDT = new Date(dropoffDate.value + 'T23:59:59');
//         const diffDays = Math.ceil((dropoffDT - pickupDT) / (1000 * 60 * 60 * 24));

//         if (diffDays > 1) {
//             multiDaySection.style.display = 'block';
            
//             useCustomTimesToggle.checked = false;
//             isCustomTimesMode = false;
//             defaultTimeSection.style.display = 'block';
//             dailyScheduleContainer.style.display = 'none';
            
//             dailySchedules = {};
//             dailyScheduleContainer.innerHTML = '';
            
//             let minHours = getMinimumHours();
            
//             // Initialize daily schedules with empty times
//             for (let i = 0; i < diffDays; i++) {
//                 const currentDay = new Date(pickupDT);
//                 currentDay.setDate(currentDay.getDate() + i);
//                 dailySchedules[i] = {
//                     date: currentDay.toISOString().split('T')[0],
//                     from: '',
//                     to: ''
//                 };
//             }
//         } else {
//             multiDaySection.style.display = 'none';
//         }
//     }

//     function getMinimumHours() {
//         if (!currentServiceType) { detectServiceType(); }
        
//         if (currentServiceType === 'chauffeur') {
//             const variantSelector = document.querySelector('input[name="option1"]:checked');
//             if (variantSelector) {
//                 const variantTitle = variantSelector.value;
//                 const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
//                 if (hourMatch) {
//                     return parseInt(hourMatch[1]);
//                 }
//             }
//             return 4;
//         } else if (currentServiceType === 'self-drive') {
//             return 12;
//         }
//         return 4;
//     }

//     function createDayRow(date, index, minHours) {
//         const dayRow = document.createElement('div');
//         dayRow.className = 'day-row';
//         dayRow.id = `day-row-${index}`;

//         const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
//         const dayDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

//         const currentFrom = dailySchedules[index]?.from || '';
//         const currentTo = dailySchedules[index]?.to || '';

//         dayRow.innerHTML = `
//             <div class="day-row-header">${dayName} ${dayDate}</div>
//             <div class="day-time-inputs">
//                 <div class="time-input-group">
//                     <label>From</label>
//                     <select class="day-from-time" data-day="${index}">
//                         <option value="">Select Time</option>
//                         ${generateTimeOptions(currentFrom)}
//                     </select>
//                 </div>
//                 <div class="time-input-group">
//                     <label>To</label>
//                     <select class="day-to-time" data-day="${index}">
//                         <option value="">Select Time</option>
//                         ${generateTimeOptions(currentTo)}
//                     </select>
//                 </div>
//             </div>
//             <div class="extra-hours-warning" id="warning-${index}" style="display:none;"></div>
//         `;

//         dailyScheduleContainer.appendChild(dayRow);

//         const fromSelect = dayRow.querySelector('.day-from-time');
//         const toSelect = dayRow.querySelector('.day-to-time');

//         fromSelect.addEventListener('change', function() {
//             dailySchedules[index].from = this.value;
//             validateDayHours(index, minHours);
//         });

//         toSelect.addEventListener('change', function() {
//             dailySchedules[index].to = this.value;
//             validateDayHours(index, minHours);
//         });
//     }

//     function generateTimeOptions(selectedValue) {
//         const times = [
//             '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30',
//             '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
//             '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
//             '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
//             '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
//             '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
//         ];

//         const labels = {
//             '00:00': '12:00 AM', '00:30': '12:30 AM', '01:00': '01:00 AM', '01:30': '01:30 AM',
//             '02:00': '02:00 AM', '02:30': '02:30 AM', '03:00': '03:00 AM', '03:30': '03:30 AM',
//             '04:00': '04:00 AM', '04:30': '04:30 AM', '05:00': '05:00 AM', '05:30': '05:30 AM',
//             '06:00': '06:00 AM', '06:30': '06:30 AM', '07:00': '07:00 AM', '07:30': '07:30 AM',
//             '08:00': '08:00 AM', '08:30': '08:30 AM', '09:00': '09:00 AM', '09:30': '09:30 AM',
//             '10:00': '10:00 AM', '10:30': '10:30 AM', '11:00': '11:00 AM', '11:30': '11:30 AM',
//             '12:00': '12:00 PM', '12:30': '12:30 PM', '13:00': '01:00 PM', '13:30': '01:30 PM',
//             '14:00': '02:00 PM', '14:30': '02:30 PM', '15:00': '03:00 PM', '15:30': '03:30 PM',
//             '16:00': '04:00 PM', '16:30': '04:30 PM', '17:00': '05:00 PM', '17:30': '05:30 PM',
//             '18:00': '06:00 PM', '18:30': '06:30 PM', '19:00': '07:00 PM', '19:30': '07:30 PM',
//             '20:00': '08:00 PM', '20:30': '08:30 PM', '21:00': '09:00 PM', '21:30': '09:30 PM',
//             '22:00': '10:00 PM', '22:30': '10:30 PM', '23:00': '11:00 PM', '23:30': '11:30 PM'
//         };

//         return times.map(time => 
//             `<option value="${time}" ${time === selectedValue ? 'selected' : ''}>${labels[time]}</option>`
//         ).join('');
//     }

//     function validateDayHours(dayIndex, minHours) {
//         const schedule = dailySchedules[dayIndex];
//         const warningDiv = document.getElementById(`warning-${dayIndex}`);
        
//         if (!schedule || !schedule.from || !schedule.to) {
//             if (warningDiv) warningDiv.style.display = 'none';
//             return;
//         }

//         const fromTime = schedule.from.split(':');
//         const toTime = schedule.to.split(':');
//         const fromMinutes = parseInt(fromTime[0]) * 60 + parseInt(fromTime[1]);
//         const toMinutes = parseInt(toTime[0]) * 60 + parseInt(toTime[1]);
        
//         let diffMinutes = toMinutes - fromMinutes;
//         if (diffMinutes < 0) diffMinutes += 24 * 60;
        
//         const hours = diffMinutes / 60;
//         const extraHours = hours - minHours;

//         if (!warningDiv) return;
        
//         if (extraHours > 0) {
//             const hourlyRate = 70;
//             const extraCharge = Math.ceil(extraHours) * hourlyRate;
            
//             warningDiv.style.display = 'block';
//             warningDiv.innerHTML = `
//                 <p>⚠️ Extra Hours: <strong>${Math.ceil(extraHours)} hour${Math.ceil(extraHours) > 1 ? 's' : ''}</strong> selected</p>
//                 <p class="charge-details">Additional charge: <strong>€${extraCharge}</strong> (€70/hour × ${Math.ceil(extraHours)} hours)</p>
//             `;
//         } else if (hours < minHours) {
//             warningDiv.style.display = 'block';
//             warningDiv.innerHTML = `
//                 <p>⚠️ Below Minimum: <strong>${hours.toFixed(1)} hours</strong> selected</p>
//                 <p class="charge-details">Minimum required: <strong>${minHours} hours</strong></p>
//             `;
//         } else {
//             warningDiv.style.display = 'none';
//         }
        
//         // Recalculate total price when times change
//         calculatePrice();
//     }

//     useCustomTimesToggle.addEventListener('change', function() {
//         isCustomTimesMode = this.checked;
        
//         // Get the main form time row
//         const mainFormTimeRows = document.querySelectorAll('.rental-table tbody tr');
//         const timeRow = mainFormTimeRows[1]; // Second row contains time fields
        
//         if (isCustomTimesMode) {
//             // Hide default time section, show custom day-by-day section
//             defaultTimeSection.style.display = 'none';
//             dailyScheduleContainer.style.display = 'block';
            
//             // Hide main form time fields when custom times are active
//             if (timeRow) {
//                 timeRow.style.display = 'none';
//             }
            
//             if (dailyScheduleContainer.children.length === 0) {
//                 const minHours = getMinimumHours();
                
//                 const noticeDiv = document.createElement('div');
//                 noticeDiv.className = 'minimum-hours-notice';
//                 noticeDiv.innerHTML = `<strong>📋 Note:</strong> Minimum ${minHours} hours per day required for this service.`;
//                 dailyScheduleContainer.appendChild(noticeDiv);
                
//                 const pickupDT = new Date(pickupDate.value + 'T00:00:00');
//                 Object.keys(dailySchedules).forEach(index => {
//                     const currentDay = new Date(pickupDT);
//                     currentDay.setDate(currentDay.getDate() + parseInt(index));
//                     createDayRow(currentDay, parseInt(index), minHours);
//                 });
//             }
//         } else {
//             // Show default time section, hide custom day-by-day section
//             defaultTimeSection.style.display = 'block';
//             dailyScheduleContainer.style.display = 'none';
            
//             // Show main form time fields when using default times
//             if (timeRow) {
//                 timeRow.style.display = '';
//             }
//         }
        
//         // Recalculate price after toggle
//         calculatePrice();
//     });

//     applyDefaultTimesBtn.addEventListener('click', function() {
//         // Use times from main pickup/dropoff selects
//         const fromTime = pickupTime.value;
//         const toTime = dropoffTime.value;
        
//         if (!fromTime || !toTime) {
//             alert('Please select Pick Up Time and Drop Off Time in the main form first!');
//             return;
//         }
        
//         // Apply to all days in schedule
//         Object.keys(dailySchedules).forEach(index => {
//             dailySchedules[index].from = fromTime;
//             dailySchedules[index].to = toTime;
            
//             // Update the dropdowns if in custom mode
//             const dayRow = document.getElementById(`day-row-${index}`);
//             if (dayRow) {
//                 const fromSelect = dayRow.querySelector('.day-from-time');
//                 const toSelect = dayRow.querySelector('.day-to-time');
//                 if (fromSelect) fromSelect.value = fromTime;
//                 if (toSelect) toSelect.value = toTime;
//             }
//         });
        
//         const minHours = getMinimumHours();
        
//         // If custom times mode is ON, create day rows if they don't exist yet
//         if (isCustomTimesMode && dailyScheduleContainer.children.length === 0) {
//             const noticeDiv = document.createElement('div');
//             noticeDiv.className = 'minimum-hours-notice';
//             noticeDiv.innerHTML = `<strong>📋 Note:</strong> Minimum ${minHours} hours per day required for this service.`;
//             dailyScheduleContainer.appendChild(noticeDiv);
            
//             const pickupDT = new Date(pickupDate.value + 'T00:00:00');
//             Object.keys(dailySchedules).forEach(index => {
//                 const currentDay = new Date(pickupDT);
//                 currentDay.setDate(currentDay.getDate() + parseInt(index));
//                 createDayRow(currentDay, parseInt(index), minHours);
//             });
//         }
        
//         // Refresh warnings for all days AFTER rows are created
//         Object.keys(dailySchedules).forEach(index => {
//             validateDayHours(parseInt(index), minHours);
//         });
        
//         // Then recalculate price
//         calculatePrice();
        
//         const fromMinutes = parseInt(fromTime.split(':')[0]) * 60 + parseInt(fromTime.split(':')[1]);
//         const toMinutes = parseInt(toTime.split(':')[0]) * 60 + parseInt(toTime.split(':')[1]);
//         let diffMinutes = toMinutes - fromMinutes;
//         if (diffMinutes < 0) diffMinutes += 24 * 60;
//         const hours = diffMinutes / 60;
//         const extraHours = Math.max(0, hours - minHours);
        
//         if (extraHours > 0) {
//             const hourlyRate = 70;
//             const extraCharge = Math.ceil(extraHours) * hourlyRate;
//             const numDays = Object.keys(dailySchedules).length;
//             const totalExtraCharge = extraCharge * numDays;
//             alert(`Default time applied to all ${numDays} days!\n\n⚠️ Extra ${Math.ceil(extraHours)} hour${Math.ceil(extraHours) > 1 ? 's' : ''} per day\nAdditional charge: €${extraCharge}/day × ${numDays} days = €${totalExtraCharge} total`);
//         } else {
//             alert(`Default time applied to all ${Object.keys(dailySchedules).length} days!`);
//         }
//     });

//     [pickupDate, dropoffDate, pickupTime, dropoffTime, pickupLocation, dropoffLocation].forEach(el => {
//         el.addEventListener("change", function() {
//             calculatePrice();
//             generateDailySchedule();
//         });
//     });

//     document.addEventListener("variant:changed", function (e) {
//         if (!e.detail.variant) return;
//         dailyRate = e.detail.variant.price / 100;
//         window.RENTAL_DAILY_RATE = dailyRate;
//         dailyRateEl.textContent = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(dailyRate);
//         detectServiceType();
//         calculatePrice();
//     });

//     function saveDailyScheduleData() {
//         if (Object.keys(dailySchedules).length > 0) {
//             const scheduleArray = Object.values(dailySchedules).map(day => {
//                 return `${day.date}: ${day.from} - ${day.to}`;
//             });
//             document.getElementById('daily-schedule-data').value = scheduleArray.join('; ');
//         }
//     }

//     productForm.addEventListener("submit", function(e) {
//         if (!isDateRangeValid) {
//             e.preventDefault();
//             e.stopPropagation();
//             errorMsg.textContent = "⚠️ Please select available dates before booking.";
//             errorMsg.style.display = "block";
//             return false;
//         }
//         saveDailyScheduleData();
//     });

//     detectServiceType();
//     checkAndClearSessionData();
//     updateButtonStates();

//     function changePaymentButtonText() {
//         const paymentBtn = productForm.querySelector(".shopify-payment-button__button");
//         if (paymentBtn) {
//             if (paymentBtn.textContent.includes('Buy') || paymentBtn.textContent.includes('buy')) {
//                 paymentBtn.textContent = 'Book now';
//             }
//         }
//     }
    
//     changePaymentButtonText();
//     setInterval(changePaymentButtonText, 500);
// });

// // Variant loader
// const loader = document.createElement("div");
// loader.id = "variant-loader";
// loader.innerHTML = `<div class="loader-backdrop"><div class="loader-spinner"></div><p style="color:white;margin-top:12px;font-size:16px;">Updating...</p></div>`;
// document.body.appendChild(loader);
// loader.style.display = "flex";
// setTimeout(() => { loader.style.display = "none"; }, 1000);
// setTimeout(function () {
//     const option1Inputs = document.querySelectorAll('input[name="option1"]');
//     if (option1Inputs.length > 0) {
//         option1Inputs.forEach((input, index) => {
//             input.addEventListener("change", function () {
//                 loader.style.display = "flex";
//                 setTimeout(function () { window.location.reload(true); }, 500);
//             });
//         });
//     }
// }, 1000);

document.addEventListener("DOMContentLoaded", function () {
    const productFormNames = document.getElementsByClassName("shopify-product-form")[1];
    const productForm = document.getElementById(productFormNames.getAttribute("id"));
    if (productFormNames.length > 1) {
        const productForm = productFormNames[1];
    }

    if (!productForm) return;

    const addToCartBtn = productForm.querySelector(".product-add-to-cart__button");

    const locationPrices = {
        "Milan": 600,
        "Amsterdam": 600,
        "Geneva": 600,
        "Bruxelles": 600,
        "Vienna": 1000,
        "Cannes": 1000
    };

    const formatCurrency = (val) =>
        val === 0 ? "Free" : new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(val);

    // ✅ READ BOOKED DATES FROM SHOPIFY PRODUCT METAFIELDS
    let BOOKED_DATES = [];
    
    // This will be populated by Liquid template
    if (typeof window.RENTAL_BOOKED_DATES !== 'undefined') {
        BOOKED_DATES = window.RENTAL_BOOKED_DATES;
    }

    // Build widget HTML
    const rentalWidget = window.RENTAL_CALCULATOR_HTML || '';
    addToCartBtn.insertAdjacentHTML("beforebegin", rentalWidget);

    // Elements
    const pickupDate = document.getElementById("pickup-date");
    const dropoffDate = document.getElementById("dropoff-date");
    const pickupTime = document.getElementById("pickup-time-select");
    const dropoffTime = document.getElementById("dropoff-time-select");
    const pickupLocation = document.getElementById("pickup-location");
    const dropoffLocation = document.getElementById("dropoff-location");
    const errorMsg = document.getElementById("error-msg");

    const dailyRateEl = document.getElementById("daily-rate");
    const rentalDaysEl = document.getElementById("rental-days");
    const totalPriceEl = document.getElementById("total-price");
    const rateLabelEl = document.getElementById("rate-label");
    const durationLabelEl = document.getElementById("duration-label");

    const rentalTotalHidden = document.getElementById("rental-total-hidden");
    const rentalTotalNumeric = document.getElementById("rental-total-numeric");
    const rentalDaysHidden = document.getElementById("rental-days-hidden");
    const pickupFeeHidden = document.getElementById("pickup-fee-hidden");
    const dropoffFeeHidden = document.getElementById("dropoff-fee-hidden");

    let dailyRate = window.RENTAL_DAILY_RATE || 0;
    let currentServiceType = null;
    let isDateRangeValid = false;

    // Additional hour rates based on car model and service package
    const additionalHourRates = {
        'mercedes-s-class': { '4': 70, '6': 60, '8': 60, '10': 60, '12': 60 },
        'defender': { '4': 70, '6': 60, '8': 60, '10': 60, '12': 60 },
        'audi-q8': { '4': 65, '6': 55, '8': 55, '10': 55, '12': 55 },
        'range-rover-velar': { '4': 60, '6': 50, '8': 50, '10': 50, '12': 50 },
        'mercedes-glb': { '4': 60, '6': 50, '8': 50, '10': 50, '12': 50 },
        
        'default': { '4': 70, '6': 60, '8': 70, '10': 70, '12': 60 }
    };

    // Function to get additional hour rate based on current variant
    function getAdditionalHourRate() {
        const variantSelector = document.querySelector('input[name="option1"]:checked');
        if (!variantSelector) return 70; // Default fallback
        
        const variantTitle = variantSelector.value;
        const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
        const packageHours = hourMatch ? hourMatch[1] : '4';
        
        // Get product handle or title to determine car model
        const productTitle = document.querySelector('.product-title, h1.title, .product__title')?.textContent.toLowerCase() || '';
        const productUrl = window.location.pathname;
        
        // Determine car model from URL or title
        let carModel = 'default';
        if (productTitle.includes('mercedes s-class') || productUrl.includes('mercedes-s-class') || productUrl.includes('mercedes s class')) {
            carModel = 'mercedes-s-class';
        } else if (productTitle.includes('defender') || productUrl.includes('defender')) {
            carModel = 'defender';
        } else if (productTitle.includes('audi q8') || productUrl.includes('audi-q8')) {
            carModel = 'audi-q8';
        } else if (productTitle.includes('range rover velar') || productUrl.includes('range-rover-velar')) {
            carModel = 'range-rover-velar';
        } else if (productTitle.includes('mercedes glb') || productUrl.includes('mercedes-glb')) {
            carModel = 'mercedes-glb';
        }
        console.log('Detected carModel:', carModel, 'packageHours:', packageHours);
        
        const rates = additionalHourRates[carModel] || additionalHourRates['default'];
        return rates[packageHours] || rates['4'] || 70;
    }

    function checkAndClearSessionData() {
        const urlParams = new URLSearchParams(window.location.search);
        const fromSearch = urlParams.get('from_search');
        if (!fromSearch || fromSearch !== 'true') {
            sessionStorage.removeItem('rentalData');
            sessionStorage.removeItem('rentalSearchData');
            return false;
        }
        return true;
    }

    function detectServiceType() {
        try {
            const rentalData = sessionStorage.getItem('rentalData');
            if (rentalData) {
                const data = JSON.parse(rentalData);
                if (data.serviceType) {
                    currentServiceType = data.serviceType;
                    return currentServiceType;
                }
            }
        } catch (e) {}
        const variantSelector = document.querySelector('input[name="option1"]:checked');
        if (variantSelector) {
            const variantTitle = variantSelector.value.toLowerCase();
            if (variantTitle.includes('chauffeur')) {
                currentServiceType = 'chauffeur';
            } else if (variantTitle.includes('self drive') || variantTitle.includes('self-drive')) {
                currentServiceType = 'self-drive';
            } else if (variantTitle.includes('transfer')) {
                currentServiceType = 'transfer';
            }
        }
        return currentServiceType;
    }

    function checkDateAvailability() {
        if (!pickupDate.value || !dropoffDate.value) {
            return { available: true, message: '' };
        }
        const selectedStart = new Date(pickupDate.value);
        selectedStart.setHours(0, 0, 0, 0);
        const selectedEnd = new Date(dropoffDate.value);
        selectedEnd.setHours(23, 59, 59, 999);
        for (let booking of BOOKED_DATES) {
            const bookedStart = new Date(booking.start);
            bookedStart.setHours(0, 0, 0, 0);
            const bookedEnd = new Date(booking.end);
            bookedEnd.setHours(23, 59, 59, 999);
            if (selectedStart <= bookedEnd && selectedEnd >= bookedStart) {
                const formatDate = (date) => {
                    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
                };
                return {
                    available: false,
                    message: `⚠️ This car is already booked from ${formatDate(bookedStart)} to ${formatDate(bookedEnd)}. Please select different dates.`
                };
            }
        }
        return { available: true, message: '' };
    }

    function setMinDateTime() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const today = `${yyyy}-${mm}-${dd}`;
        pickupDate.min = today;
        dropoffDate.min = today;
    }
    setMinDateTime();

    function validateDatesAndTimes() {
        errorMsg.style.display = "none";
        errorMsg.textContent = "";
        
        if (!pickupDate.value || !dropoffDate.value || !pickupTime.value || !dropoffTime.value) {
            return { valid: false, message: "" };
        }
        
        const now = new Date();
        const pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
        const dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
        
        if (pickupDT < now) {
            return { valid: false, message: "⚠️ Pick-up date and time cannot be in the past." };
        }
        
        if (dropoffDT < now) {
            return { valid: false, message: "⚠️ Drop-off date and time cannot be in the past." };
        }
        
        if (dropoffDT <= pickupDT) {
            return { valid: false, message: "⚠️ Drop-off date and time must be after pick-up." };
        }
        
        const diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
        
        if (!currentServiceType) { detectServiceType(); }
        
        if (currentServiceType === 'chauffeur') {
            if (diffHours < 4) {
                return { valid: false, message: "⚠️ Chauffeur Service requires a minimum booking of 4 hours." };
            }
            
            const variantSelector = document.querySelector('input[name="option1"]:checked');
            if (variantSelector) {
                const variantTitle = variantSelector.value;
                const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
                if (hourMatch) {
                    const variantMinHours = parseInt(hourMatch[1]);
                    const totalHours = Math.ceil(diffHours);
                    if (totalHours < variantMinHours) {
                        return { 
                            valid: false, 
                            message: `⚠️ This variant requires a minimum of ${variantMinHours} hours. Your booking is ${totalHours} hour${totalHours !== 1 ? 's' : ''}. Please select more hours or choose a different variant.` 
                        };
                    }
                }
            }
        } else if (currentServiceType === 'self-drive') {
            if (diffHours < 12) {
                return { valid: false, message: "⚠️ Self-Drive service requires a minimum rental of 12 hours." };
            }
        } else if (currentServiceType === 'transfer') {
            if (diffHours < 0.5) {
                return { valid: false, message: "⚠️ Transfer duration must be at least 30 minutes." };
            }
        } else {
            if (diffHours < 12) {
                return { valid: false, message: "⚠️ Minimum rental duration is 12 hours." };
            }
        }
        
        const diffDays = diffHours / 24;
        if (diffDays > 90) {
            return { valid: false, message: "⚠️ Maximum rental duration is 90 days. Please contact us for longer rentals." };
        }
        
        return { valid: true, message: "" };
    }

    function calculatePrice() {
        errorMsg.style.display = "none";
        isDateRangeValid = false;
        if (!currentServiceType) { detectServiceType(); }
        let pickupFee = 0;
        let dropoffFee = locationPrices[dropoffLocation.value] || 0;
        let days = 0;
        let total = 0;
        
        const validation = validateDatesAndTimes();
        if (!validation.valid) {
            if (validation.message) {
                errorMsg.textContent = validation.message;
                errorMsg.style.display = "block";
            }
            rentalDaysEl.textContent = '0';
            totalPriceEl.textContent = '-';
            updatePaymentInfo(0, 0);
            isDateRangeValid = false;
            updateButtonStates();
            return;
        }
        
        if (currentServiceType === 'transfer') {
            rateLabelEl.textContent = 'Daily Rate';
            durationLabelEl.textContent = 'Rental Days';
            rentalDaysEl.textContent = '0';
            rentalDaysHidden.value = 0;
            dailyRateEl.textContent = formatCurrency(dailyRate);
            total = dailyRate + dropoffFee;
        } else if (currentServiceType === 'chauffeur') {
            // For chauffeur, check if multi-day schedule is active
            const pickupDT = new Date(pickupDate.value + 'T00:00:00');
            const dropoffDT = new Date(dropoffDate.value + 'T23:59:59');
            const diffDays = Math.ceil((dropoffDT - pickupDT) / (1000 * 60 * 60 * 24));
            
            rateLabelEl.textContent = 'Base Rate per Day';
            durationLabelEl.textContent = 'Total Days';
            
            const variantSelector = document.querySelector('input[name="option1"]:checked');
            let variantMinHours = 4;
            
            if (variantSelector) {
                const variantTitle = variantSelector.value;
                const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
                if (hourMatch) {
                    variantMinHours = parseInt(hourMatch[1]);
                }
            }
            
            // Check if multi-day section is active and has times filled
            const hasMultiDayTimes = diffDays > 1 && Object.keys(dailySchedules).length > 0 && 
                                     Object.values(dailySchedules).some(day => day.from && day.to);
            
            if (hasMultiDayTimes) {
                // Multi-day calculation: sum up each day's price
                let totalMultiDayPrice = 0;
                let totalAdditionalHours = 0;
                const additionalHourRate = getAdditionalHourRate();
                let daysWithTimes = 0;
                
                Object.keys(dailySchedules).forEach(index => {
                    const daySchedule = dailySchedules[index];
                    if (daySchedule.from && daySchedule.to) {
                        daysWithTimes++;
                        const fromMinutes = parseInt(daySchedule.from.split(':')[0]) * 60 + parseInt(daySchedule.from.split(':')[1]);
                        const toMinutes = parseInt(daySchedule.to.split(':')[0]) * 60 + parseInt(daySchedule.to.split(':')[1]);
                        let diffMinutes = toMinutes - fromMinutes;
                        if (diffMinutes < 0) diffMinutes += 24 * 60;
                        
                        const hours = diffMinutes / 60;
                        const extraHours = Math.max(0, hours - variantMinHours);
                        
                        // Each day: base rate + extra hours charge
                        const dayPrice = dailyRate + (Math.ceil(extraHours) * additionalHourRate);
                        totalMultiDayPrice += dayPrice;
                        totalAdditionalHours += Math.ceil(extraHours);
                    }
                });
                
                dailyRateEl.textContent = formatCurrency(dailyRate);
                rentalDaysEl.textContent = daysWithTimes;
                rentalDaysHidden.value = daysWithTimes;
                
                // Add drop-off fee to multi-day total
                total = totalMultiDayPrice + dropoffFee;
                
                // Hide single-day extra hours info for multi-day
                const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
                extraHoursInfoDiv.style.display = "none";
            } else {
                // Single day calculation or multi-day without custom times
                if (!pickupTime.value || !dropoffTime.value) {
                    // No times selected yet
                    dailyRateEl.textContent = formatCurrency(dailyRate);
                    rentalDaysEl.textContent = diffDays;
                    rentalDaysHidden.value = diffDays;
                    total = 0;
                } else {
                    dailyRateEl.textContent = formatCurrency(dailyRate);
                    rentalDaysEl.textContent = diffDays;
                    rentalDaysHidden.value = diffDays;
                    
                    const additionalHourRate = getAdditionalHourRate();
                    
                    // For multi-day, calculate hours per day based on TIME difference only
                    if (diffDays > 1) {
                        // Calculate daily hours from selected times (not full datetime range)
                        const pickupTimeMinutes = parseInt(pickupTime.value.split(':')[0]) * 60 + parseInt(pickupTime.value.split(':')[1]);
                        const dropoffTimeMinutes = parseInt(dropoffTime.value.split(':')[0]) * 60 + parseInt(dropoffTime.value.split(':')[1]);
                        let dailyMinutes = dropoffTimeMinutes - pickupTimeMinutes;
                        if (dailyMinutes < 0) dailyMinutes += 24 * 60; // Handle overnight
                        
                        const hoursPerDay = dailyMinutes / 60;
                        const extraHoursPerDay = Math.max(0, hoursPerDay - variantMinHours);
                        const pricePerDay = dailyRate + (Math.ceil(extraHoursPerDay) * additionalHourRate);
                        total = (pricePerDay * diffDays) + dropoffFee;
                        
                        // Show warning for multi-day with default times
                        const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
                        if (extraHoursPerDay > 0) {
                            const roundedExtraHours = Math.ceil(extraHoursPerDay);
                            const extraChargePerDay = roundedExtraHours * additionalHourRate;
                            const totalExtraCharge = extraChargePerDay * diffDays;
                            extraHoursInfoDiv.innerHTML = `⚠️ <strong>Extra Hours Per Day:</strong> ${roundedExtraHours} hour${roundedExtraHours > 1 ? 's' : ''} beyond package<br><strong>Additional Charge:</strong> €${extraChargePerDay}/day × ${diffDays} days = €${totalExtraCharge} total (€${additionalHourRate}/hour)`;
                            extraHoursInfoDiv.style.display = "block";
                        } else {
                            extraHoursInfoDiv.style.display = "none";
                        }
                    } else {
                        // Single day - calculate full datetime range
                        let mainPickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
                        let mainDropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
                        
                        let diffHours = (mainDropoffDT - mainPickupDT) / (1000 * 60 * 60);
                        let totalHours = Math.ceil(diffHours);
                        let additionalHours = Math.max(0, totalHours - variantMinHours);
                        
                        total = dailyRate + (additionalHours * additionalHourRate) + dropoffFee;
                        
                        // Show single-day extra hours info
                        const extraHoursInfoDiv = document.getElementById("single-day-extra-hours-info");
                        if (additionalHours > 0) {
                            const extraCharge = additionalHours * additionalHourRate;
                            extraHoursInfoDiv.innerHTML = `⚠️ <strong>Extra Hours Selected:</strong> ${additionalHours} hour${additionalHours > 1 ? 's' : ''} beyond package<br><strong>Additional Charge:</strong> €${extraCharge} (€${additionalHourRate}/hour × ${additionalHours} hours)`;
                            extraHoursInfoDiv.style.display = "block";
                        } else {
                            extraHoursInfoDiv.style.display = "none";
                        }
                    }
                }
            }
        } else if (currentServiceType === 'self-drive') {
            rateLabelEl.textContent = 'Daily Rate';
            durationLabelEl.textContent = 'Rental Days';
            
            let pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
            let dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
            let diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
            
            days = Math.ceil(diffHours / 24);
            
            // Validate self-drive day ranges based on variant
            const variantSelector = document.querySelector('input[name="option1"]:checked');
            if (variantSelector) {
                const variantTitle = variantSelector.value.toLowerCase();
                let minDays = 0;
                let maxDays = 999;
                let packageName = '';
                
                // Extract day range from variant title (e.g., "Self Drive 4-7 days")
                const dayRangeMatch = variantTitle.match(/(\d+)-(\d+)\s*days?/i);
                if (dayRangeMatch) {
                    minDays = parseInt(dayRangeMatch[1]);
                    maxDays = parseInt(dayRangeMatch[2]);
                    packageName = `Self Drive ${minDays}-${maxDays} days`;
                } else {
                    // Check for single day variants like "Self Drive 1-3 days" or "3 days"
                    const singleDayMatch = variantTitle.match(/(\d+)\s*days?/i);
                    if (singleDayMatch) {
                        const extractedDays = parseInt(singleDayMatch[1]);
                        // Assume it's part of a range, try to infer
                        if (variantTitle.includes('1') || variantTitle.includes('one')) {
                            minDays = 1;
                            maxDays = 3;
                            packageName = 'Self Drive 1-3 days';
                        }
                    }
                }
                
                // Validate selected days against package range
                if (minDays > 0 && (days < minDays || days > maxDays)) {
                    errorMsg.textContent = `⚠️ You selected the "${packageName}" package, which requires booking between ${minDays} and ${maxDays} days. You've selected ${days} day${days !== 1 ? 's' : ''}. Please adjust your dates or select a different package.`;
                    errorMsg.style.display = "block";
                    isDateRangeValid = false;
                    rentalDaysEl.textContent = days;
                    totalPriceEl.textContent = '-';
                    updatePaymentInfo(0, 0);
                    updateButtonStates();
                    return;
                }
            }
            
            rentalDaysEl.textContent = days;
            rentalDaysHidden.value = days;
            dailyRateEl.textContent = formatCurrency(dailyRate);
            
            const baseTotal = (days * dailyRate) + dropoffFee;
            const franchiseAmount = 1500;
            total = baseTotal + franchiseAmount;
        } else {
            rateLabelEl.textContent = 'Daily Rate';
            durationLabelEl.textContent = 'Rental Days';
            
            if (pickupDate.value && dropoffDate.value && pickupTime.value && dropoffTime.value) {
                let pickupDT = new Date(pickupDate.value + "T" + pickupTime.value);
                let dropoffDT = new Date(dropoffDate.value + "T" + dropoffTime.value);
                let diffHours = (dropoffDT - pickupDT) / (1000 * 60 * 60);
                days = Math.ceil(diffHours / 24);
                rentalDaysEl.textContent = days;
                rentalDaysHidden.value = days;
                total = (days * dailyRate) + dropoffFee;
            }
        }
        const availability = checkDateAvailability();
        if (!availability.available) {
            errorMsg.textContent = availability.message;
            errorMsg.style.display = "block";
            isDateRangeValid = false;
            updateButtonStates();
            return;
        } else {
            isDateRangeValid = true;
        }
        pickupFeeHidden.value = pickupFee;
        dropoffFeeHidden.value = dropoffFee;
        const formatted = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(total);
        totalPriceEl.textContent = formatted;
        rentalTotalHidden.value = formatted;
        rentalTotalNumeric.value = total.toFixed(2);
        
        updateTotalPriceInSession(total);
        updatePaymentInfo(total, dailyRate);
        updateButtonStates();
    }

    function updateTotalPriceInSession(totalPrice) {
        try {
            let rentalSearchData = sessionStorage.getItem('rentalSearchData');
            let data = {};
            
            if (rentalSearchData) {
                data = JSON.parse(rentalSearchData);
            }
            
            data.totalPrice = totalPrice;
            data.pickupLocation = pickupLocation.value;
            data.dropoffLocation = dropoffLocation.value;
            data.pickupDate = pickupDate.value;
            data.pickupTime = pickupTime.value;
            data.returnDate = dropoffDate.value;
            data.returnTime = dropoffTime.value;
            data.serviceType = currentServiceType;
            
            sessionStorage.setItem('rentalSearchData', JSON.stringify(data));
        } catch (error) {
            console.error('Error updating total price in session storage:', error);
        }
    }

    function updatePaymentInfo(totalPrice, depositAmount) {
        const paymentInfoBox = document.getElementById("payment-info-box");
        const paymentTotal = document.getElementById("payment-total");
        const paymentBalance = document.getElementById("payment-balance");
        if (totalPrice > 0) {
            const balance = totalPrice - depositAmount;
            const formattedTotal = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(totalPrice);
            const formattedBalance = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(balance);
            paymentTotal.textContent = formattedTotal;
            paymentBalance.textContent = formattedBalance;
            paymentInfoBox.style.display = "block";
        } else {
            paymentInfoBox.style.display = "none";
        }
    }

    function updateButtonStates() {
        const paymentBtn = productForm.querySelector(".shopify-payment-button__button");
        if (!isDateRangeValid || !pickupDate.value || !dropoffDate.value) {
            addToCartBtn.disabled = true;
            addToCartBtn.style.opacity = "0.5";
            addToCartBtn.style.cursor = "not-allowed";
            if (paymentBtn) {
                paymentBtn.disabled = true;
                paymentBtn.style.opacity = "0.5";
                paymentBtn.style.cursor = "not-allowed";
            }
        } else {
            addToCartBtn.disabled = false;
            addToCartBtn.style.opacity = "1";
            addToCartBtn.style.cursor = "pointer";
            if (paymentBtn) {
                paymentBtn.disabled = false;
                paymentBtn.style.opacity = "1";
                paymentBtn.style.cursor = "pointer";
            }
        }
    }

    // Multi-Day Schedule Functions
    const multiDaySection = document.getElementById('multi-day-section');
    const dailyScheduleContainer = document.getElementById('daily-schedule-container');
    const defaultTimeSection = document.getElementById('default-time-section');
    const useCustomTimesToggle = document.getElementById('use-custom-times-toggle');
    const applyDefaultTimesBtn = document.getElementById('apply-default-times-btn');
    let dailySchedules = {};
    let isCustomTimesMode = false;

    function generateDailySchedule() {
        if (!pickupDate.value || !dropoffDate.value) {
            multiDaySection.style.display = 'none';
            return;
        }

        if (!currentServiceType) { detectServiceType(); }
        if (currentServiceType !== 'chauffeur') {
            multiDaySection.style.display = 'none';
            return;
        }

        const pickupDT = new Date(pickupDate.value + 'T00:00:00');
        const dropoffDT = new Date(dropoffDate.value + 'T23:59:59');
        const diffDays = Math.ceil((dropoffDT - pickupDT) / (1000 * 60 * 60 * 24));

        if (diffDays > 1) {
            multiDaySection.style.display = 'block';
            
            useCustomTimesToggle.checked = false;
            isCustomTimesMode = false;
            defaultTimeSection.style.display = 'block';
            dailyScheduleContainer.style.display = 'none';
            
            dailySchedules = {};
            dailyScheduleContainer.innerHTML = '';
            
            let minHours = getMinimumHours();
            
            // Initialize daily schedules with empty times
            for (let i = 0; i < diffDays; i++) {
                const currentDay = new Date(pickupDT);
                currentDay.setDate(currentDay.getDate() + i);
                dailySchedules[i] = {
                    date: currentDay.toISOString().split('T')[0],
                    from: '',
                    to: ''
                };
            }
        } else {
            multiDaySection.style.display = 'none';
        }
    }

    function getMinimumHours() {
        if (!currentServiceType) { detectServiceType(); }
        
        if (currentServiceType === 'chauffeur') {
            const variantSelector = document.querySelector('input[name="option1"]:checked');
            if (variantSelector) {
                const variantTitle = variantSelector.value;
                const hourMatch = variantTitle.match(/(\d+)\s*hour?s?/i);
                if (hourMatch) {
                    return parseInt(hourMatch[1]);
                }
            }
            return 4;
        } else if (currentServiceType === 'self-drive') {
            return 12;
        }
        return 4;
    }

    function createDayRow(date, index, minHours) {
        const dayRow = document.createElement('div');
        dayRow.className = 'day-row';
        dayRow.id = `day-row-${index}`;

        const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
        const dayDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

        const currentFrom = dailySchedules[index]?.from || '';
        const currentTo = dailySchedules[index]?.to || '';

        dayRow.innerHTML = `
            <div class="day-row-header">${dayName} ${dayDate}</div>
            <div class="day-time-inputs">
                <div class="time-input-group">
                    <label>From</label>
                    <select class="day-from-time" data-day="${index}">
                        <option value="">Select Time</option>
                        ${generateTimeOptions(currentFrom)}
                    </select>
                </div>
                <div class="time-input-group">
                    <label>To</label>
                    <select class="day-to-time" data-day="${index}">
                        <option value="">Select Time</option>
                        ${generateTimeOptions(currentTo)}
                    </select>
                </div>
            </div>
            <div class="extra-hours-warning" id="warning-${index}" style="display:none;"></div>
        `;

        dailyScheduleContainer.appendChild(dayRow);

        const fromSelect = dayRow.querySelector('.day-from-time');
        const toSelect = dayRow.querySelector('.day-to-time');

        fromSelect.addEventListener('change', function() {
            dailySchedules[index].from = this.value;
            validateDayHours(index, minHours);
        });

        toSelect.addEventListener('change', function() {
            dailySchedules[index].to = this.value;
            validateDayHours(index, minHours);
        });
    }

    function generateTimeOptions(selectedValue) {
        const times = [
            '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30',
            '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
            '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
            '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
            '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
            '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
        ];

        const labels = {
            '00:00': '12:00 AM', '00:30': '12:30 AM', '01:00': '01:00 AM', '01:30': '01:30 AM',
            '02:00': '02:00 AM', '02:30': '02:30 AM', '03:00': '03:00 AM', '03:30': '03:30 AM',
            '04:00': '04:00 AM', '04:30': '04:30 AM', '05:00': '05:00 AM', '05:30': '05:30 AM',
            '06:00': '06:00 AM', '06:30': '06:30 AM', '07:00': '07:00 AM', '07:30': '07:30 AM',
            '08:00': '08:00 AM', '08:30': '08:30 AM', '09:00': '09:00 AM', '09:30': '09:30 AM',
            '10:00': '10:00 AM', '10:30': '10:30 AM', '11:00': '11:00 AM', '11:30': '11:30 AM',
            '12:00': '12:00 PM', '12:30': '12:30 PM', '13:00': '01:00 PM', '13:30': '01:30 PM',
            '14:00': '02:00 PM', '14:30': '02:30 PM', '15:00': '03:00 PM', '15:30': '03:30 PM',
            '16:00': '04:00 PM', '16:30': '04:30 PM', '17:00': '05:00 PM', '17:30': '05:30 PM',
            '18:00': '06:00 PM', '18:30': '06:30 PM', '19:00': '07:00 PM', '19:30': '07:30 PM',
            '20:00': '08:00 PM', '20:30': '08:30 PM', '21:00': '09:00 PM', '21:30': '09:30 PM',
            '22:00': '10:00 PM', '22:30': '10:30 PM', '23:00': '11:00 PM', '23:30': '11:30 PM'
        };

        return times.map(time => 
            `<option value="${time}" ${time === selectedValue ? 'selected' : ''}>${labels[time]}</option>`
        ).join('');
    }

    function validateDayHours(dayIndex, minHours) {
        const schedule = dailySchedules[dayIndex];
        const warningDiv = document.getElementById(`warning-${dayIndex}`);
        
        if (!schedule || !schedule.from || !schedule.to) {
            if (warningDiv) warningDiv.style.display = 'none';
            return;
        }

        const fromTime = schedule.from.split(':');
        const toTime = schedule.to.split(':');
        const fromMinutes = parseInt(fromTime[0]) * 60 + parseInt(fromTime[1]);
        const toMinutes = parseInt(toTime[0]) * 60 + parseInt(toTime[1]);
        
        let diffMinutes = toMinutes - fromMinutes;
        if (diffMinutes < 0) diffMinutes += 24 * 60;
        
        const hours = diffMinutes / 60;
        const extraHours = hours - minHours;

        if (!warningDiv) return;
        
        if (extraHours > 0) {
            const hourlyRate = getAdditionalHourRate();
            const extraCharge = Math.ceil(extraHours) * hourlyRate;
            
            warningDiv.style.display = 'block';
            warningDiv.innerHTML = `
                <p>⚠️ Extra Hours: <strong>${Math.ceil(extraHours)} hour${Math.ceil(extraHours) > 1 ? 's' : ''}</strong> selected</p>
                <p class="charge-details">Additional charge: <strong>€${extraCharge}</strong> (€${hourlyRate}/hour × ${Math.ceil(extraHours)} hours)</p>
            `;
        } else if (hours < minHours) {
            warningDiv.style.display = 'block';
            warningDiv.innerHTML = `
                <p>⚠️ Below Minimum: <strong>${hours.toFixed(1)} hours</strong> selected</p>
                <p class="charge-details">Minimum required: <strong>${minHours} hours</strong></p>
            `;
        } else {
            warningDiv.style.display = 'none';
        }
        
        // Recalculate total price when times change
        calculatePrice();
    }

    useCustomTimesToggle.addEventListener('change', function() {
        isCustomTimesMode = this.checked;
        
        // Get the main form time row
        const mainFormTimeRows = document.querySelectorAll('.rental-table tbody tr');
        const timeRow = mainFormTimeRows[1]; // Second row contains time fields
        
        if (isCustomTimesMode) {
            // Hide default time section, show custom day-by-day section
            defaultTimeSection.style.display = 'none';
            dailyScheduleContainer.style.display = 'block';
            
            // Hide main form time fields when custom times are active
            if (timeRow) {
                timeRow.style.display = 'none';
            }
            
            if (dailyScheduleContainer.children.length === 0) {
                const minHours = getMinimumHours();
                
                const noticeDiv = document.createElement('div');
                noticeDiv.className = 'minimum-hours-notice';
                noticeDiv.innerHTML = `<strong>📋 Note:</strong> Minimum ${minHours} hours per day required for this service.`;
                dailyScheduleContainer.appendChild(noticeDiv);
                
                const pickupDT = new Date(pickupDate.value + 'T00:00:00');
                Object.keys(dailySchedules).forEach(index => {
                    const currentDay = new Date(pickupDT);
                    currentDay.setDate(currentDay.getDate() + parseInt(index));
                    createDayRow(currentDay, parseInt(index), minHours);
                });
            }
        } else {
            // Show default time section, hide custom day-by-day section
            defaultTimeSection.style.display = 'block';
            dailyScheduleContainer.style.display = 'none';
            
            // Show main form time fields when using default times
            if (timeRow) {
                timeRow.style.display = '';
            }
        }
        
        // Recalculate price after toggle (this will show main form warning if applicable)
        calculatePrice();
    });

    applyDefaultTimesBtn.addEventListener('click', function() {
        // Use times from main pickup/dropoff selects
        const fromTime = pickupTime.value;
        const toTime = dropoffTime.value;
        
        if (!fromTime || !toTime) {
            alert('Please select Pick Up Time and Drop Off Time in the main form first!');
            return;
        }
        
        // Apply to all days in schedule
        Object.keys(dailySchedules).forEach(index => {
            dailySchedules[index].from = fromTime;
            dailySchedules[index].to = toTime;
            
            // Update the dropdowns if in custom mode
            const dayRow = document.getElementById(`day-row-${index}`);
            if (dayRow) {
                const fromSelect = dayRow.querySelector('.day-from-time');
                const toSelect = dayRow.querySelector('.day-to-time');
                if (fromSelect) fromSelect.value = fromTime;
                if (toSelect) toSelect.value = toTime;
            }
        });
        
        const minHours = getMinimumHours();
        
        // If custom times mode is ON, create day rows if they don't exist yet
        if (isCustomTimesMode && dailyScheduleContainer.children.length === 0) {
            const noticeDiv = document.createElement('div');
            noticeDiv.className = 'minimum-hours-notice';
            noticeDiv.innerHTML = `<strong>📋 Note:</strong> Minimum ${minHours} hours per day required for this service.`;
            dailyScheduleContainer.appendChild(noticeDiv);
            
            const pickupDT = new Date(pickupDate.value + 'T00:00:00');
            Object.keys(dailySchedules).forEach(index => {
                const currentDay = new Date(pickupDT);
                currentDay.setDate(currentDay.getDate() + parseInt(index));
                createDayRow(currentDay, parseInt(index), minHours);
            });
        }
        
        // Refresh warnings for all days AFTER rows are created
        Object.keys(dailySchedules).forEach(index => {
            validateDayHours(parseInt(index), minHours);
        });
        
        // Then recalculate price
        calculatePrice();
        
        const fromMinutes = parseInt(fromTime.split(':')[0]) * 60 + parseInt(fromTime.split(':')[1]);
        const toMinutes = parseInt(toTime.split(':')[0]) * 60 + parseInt(toTime.split(':')[1]);
        let diffMinutes = toMinutes - fromMinutes;
        if (diffMinutes < 0) diffMinutes += 24 * 60;
        const hours = diffMinutes / 60;
        const extraHours = Math.max(0, hours - minHours);
        
        if (extraHours > 0) {
            const hourlyRate = getAdditionalHourRate();
            const extraCharge = Math.ceil(extraHours) * hourlyRate;
            const numDays = Object.keys(dailySchedules).length;
            const totalExtraCharge = extraCharge * numDays;
            alert(`Default time applied to all ${numDays} days!\n\n⚠️ Extra ${Math.ceil(extraHours)} hour${Math.ceil(extraHours) > 1 ? 's' : ''} per day\nAdditional charge: €${extraCharge}/day × ${numDays} days = €${totalExtraCharge} total (€${hourlyRate}/hour)`);
        } else {
            alert(`Default time applied to all ${Object.keys(dailySchedules).length} days!`);
        }
    });

    [pickupDate, dropoffDate, pickupTime, dropoffTime, pickupLocation, dropoffLocation].forEach(el => {
        el.addEventListener("change", function() {
            calculatePrice();
            generateDailySchedule();
        });
    });

    document.addEventListener("variant:changed", function (e) {
        if (!e.detail.variant) return;
        dailyRate = e.detail.variant.price / 100;
        window.RENTAL_DAILY_RATE = dailyRate;
        dailyRateEl.textContent = new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }).format(dailyRate);
        detectServiceType();
        calculatePrice();
    });

    function saveDailyScheduleData() {
        if (Object.keys(dailySchedules).length > 0) {
            const scheduleArray = Object.values(dailySchedules).map(day => {
                return `${day.date}: ${day.from} - ${day.to}`;
            });
            document.getElementById('daily-schedule-data').value = scheduleArray.join('; ');
        }
    }

    productForm.addEventListener("submit", function(e) {
        if (!isDateRangeValid) {
            e.preventDefault();
            e.stopPropagation();
            errorMsg.textContent = "⚠️ Please select available dates before booking.";
            errorMsg.style.display = "block";
            return false;
        }
        saveDailyScheduleData();
    });

    detectServiceType();
    checkAndClearSessionData();
    updateButtonStates();

    function changePaymentButtonText() {
        const paymentBtn = productForm.querySelector(".shopify-payment-button__button");
        if (paymentBtn) {
            if (paymentBtn.textContent.includes('Buy') || paymentBtn.textContent.includes('buy')) {
                paymentBtn.textContent = 'Book now';
            }
        }
    }
    
    changePaymentButtonText();
    setInterval(changePaymentButtonText, 500);
});

// Variant loader
const loader = document.createElement("div");
loader.id = "variant-loader";
loader.innerHTML = `<div class="loader-backdrop"><div class="loader-spinner"></div><p style="color:white;margin-top:12px;font-size:16px;">Updating...</p></div>`;
document.body.appendChild(loader);
loader.style.display = "flex";
setTimeout(() => { loader.style.display = "none"; }, 1000);
setTimeout(function () {
    const option1Inputs = document.querySelectorAll('input[name="option1"]');
    if (option1Inputs.length > 0) {
        option1Inputs.forEach((input, index) => {
            input.addEventListener("change", function () {
                loader.style.display = "flex";
                setTimeout(function () { window.location.reload(true); }, 500);
            });
        });
    }
}, 1000);
